import { MutationHookOptions, useMutation } from '@apollo/client'
import { CodeReveal, CodeRevealVariables } from '__generatedTypes__/CodeReveal'
import { CODE_REVEAL } from 'queries/institutionalCodes'

export function useCodeRevealMutation(options?: MutationHookOptions<CodeReveal, CodeRevealVariables>) {
  return useMutation<CodeReveal, CodeRevealVariables>(CODE_REVEAL, options)
}
